import { render, staticRenderFns } from "./dialog-form.vue?vue&type=template&id=18531216&"
import script from "./dialog-form.vue?vue&type=script&lang=js&"
export * from "./dialog-form.vue?vue&type=script&lang=js&"
import style0 from "./dialog-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports